import "../scss/components/_cart.scss";
import "../scss/components/_cartupsell.scss";
import "../scss/components/_barprogress.scss";

import { sidecartDefer } from "../components/cart-load-defer";
sidecartDefer();
